import DataService from "../provider/Data/DataService";
import { CHANGE_APP_PROPS, CHANGE_DATA_PROPS } from "./ActionConstants";

export function actionGetCivilStatusList() {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetCivilStatusList().then(response => {
			dispatch({
				type: CHANGE_DATA_PROPS,
				props: {
					civilStatusList: response
				}
			});
		});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGetCivilStatusList() {
	return await DataService.getCivilStatus();
}

export function actionGetRolList() {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetRolList().then(response => {
			dispatch({
				type: CHANGE_DATA_PROPS,
				props: {
					rolList: response
				}
			});
		});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGetRolList() {
	return await DataService.getRol();
}

export function actionGetGendersList() {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetGendersList().then(response => {
			dispatch({
				type: CHANGE_DATA_PROPS,
				props: {
					gendersList: response
				}
			});
		});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGetGendersList() {
	return await DataService.getGenders();
}

export function actionGetNationalitiesList() {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetNationalitiesList().then(response => {
			dispatch({
				type: CHANGE_DATA_PROPS,
				props: {
					nationalitiesList: response
				}
			});
		});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGetNationalitiesList() {
	return await DataService.getNationalities();
}

export function actionGetRelationshipList() {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetRelationshipList().then(response => {
			dispatch({
				type: CHANGE_DATA_PROPS,
				props: {
					relationshipList: response
				}
			});
		});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGetRelationshipList() {
	return await DataService.getRelationship();
}
export function actionGetAffiliateStatusCantNow() {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetAffiliateStatusCantNow().then(response => {
			dispatch({
				type: CHANGE_DATA_PROPS,
				props: {
					listAffiModuleBI: response
				}
			});
		});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncGetAffiliateStatusCantNow() {
	return await DataService.getAffiliateStatusCantNow();
}



// WEBPACK FOOTER //
// ./src/actions/DataActions.js